/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Scope_ProductsInputs */

const vi_warehouse_stats_scope_products = /** @type {(inputs: Warehouse_Stats_Scope_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho hàng bán`)
};

/**

* @param {Warehouse_Stats_Scope_ProductsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_scope_products = /** @type {((inputs?: Warehouse_Stats_Scope_ProductsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Scope_ProductsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_scope_products(inputs)
});